import { Children, cloneElement, ComponentProps, isValidElement, ReactElement } from 'react';
import clsx from 'clsx';

import styles from './Button.module.css';

interface ButtonProps extends ComponentProps<'button'> {
  variant?: 'default' | 'icon';
  asChild?: boolean;
}

export const Button = ({
  variant = 'default',
  className,
  asChild,
  children,
  ...props
}: ButtonProps) => {
  const clx = clsx(styles.btn, styles[variant], className);

  if (asChild && isValidElement(children)) {
    return cloneElement(Children.only(children) as ReactElement<{ className?: string }>, {
      className: clsx(
        (children as ReactElement<{ className?: string }>).props.className,
        clx
      ),
      ...props,
    });
  }

  return (
    <button className={clx} {...props}>
      {children}
    </button>
  );
};
